const Attachment = ({
  stroke = '#262F39',
  className,
  style,
  width = '24',
  height = '24',
}) => {
  return (
    <svg
      className={className}
      style={style}
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M12.3302 12.15L9.86018 14.62C8.49018 15.99 8.49018 18.2 9.86018 19.57C11.2302 20.94 13.4402 20.94 14.8102 19.57L18.7002 15.68C21.4302 12.95 21.4302 8.51001 18.7002 5.78001C15.9702 3.05001 11.5302 3.05001 8.80018 5.78001L4.56018 10.02C2.22018 12.36 2.22018 16.16 4.56018 18.51'
        stroke={stroke}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Attachment